import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "@/lib/i18n";

export default function Footer() {
  const { t } = useI18n();
  return (
    <footer className="bg-slate-900 text-slate-300 mt-16" data-testid="site-footer">
      <div className="nc-container py-14 grid grid-cols-1 md:grid-cols-4 gap-8">
        <div>
          <div className="flex items-center gap-2 mb-3">
            <img src="/nakshacart-logo.png" alt="NakshaCart" className="w-9 h-9 object-contain" width="36" height="36" />
            <span className="text-lg font-semibold text-white" style={{ fontFamily: "Poppins" }}>NakshaCart</span>
          </div>
          <p className="text-sm text-slate-400 leading-relaxed max-w-xs">{t("footer.tagline")}</p>
        </div>
        <div>
          <div className="text-sm font-semibold text-white mb-3">{t("footer.product")}</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/plans" className="hover:text-emerald-400">{t("nav.plans")}</Link></li>
            <li><Link to="/pricing" className="hover:text-emerald-400">{t("nav.pricing")}</Link></li>
            <li><Link to="/customize" className="hover:text-emerald-400">{t("nav.customize")}</Link></li>
            <li><Link to="/partner/register" className="hover:text-emerald-400">{t("nav.partnerWith")}</Link></li>
            <li><Link to="/affiliate" className="hover:text-emerald-400">{t("footer.affiliate")}</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-sm font-semibold text-white mb-3">{t("footer.company")}</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/about" className="hover:text-emerald-400">{t("footer.about")}</Link></li>
            <li><Link to="/services" className="hover:text-emerald-400">{t("footer.services")}</Link></li>
            <li><Link to="/contact" className="hover:text-emerald-400">{t("nav.contact")}</Link></li>
            <li><Link to="/blog" className="hover:text-emerald-400">{t("nav.blog")}</Link></li>
            <li><Link to="/careers" className="hover:text-emerald-400">{t("footer.careers")}</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-sm font-semibold text-white mb-3">{t("footer.legal")}</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/legal" className="hover:text-emerald-400 font-medium">{t("footer.legalAll")}</Link></li>
            <li><Link to="/terms" className="hover:text-emerald-400">{t("footer.terms")}</Link></li>
            <li><Link to="/privacy" className="hover:text-emerald-400">{t("footer.privacy")}</Link></li>
            <li><Link to="/refund" className="hover:text-emerald-400">{t("footer.refund")}</Link></li>
            <li><Link to="/cancellation" className="hover:text-emerald-400">{t("footer.cancellation")}</Link></li>
            <li><Link to="/delivery" className="hover:text-emerald-400">{t("footer.delivery")}</Link></li>
            <li><Link to="/admin/login" className="hover:text-emerald-400">{t("footer.adminLogin")}</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-slate-800">
        <div className="nc-container py-5 text-xs text-slate-500 flex flex-col sm:flex-row justify-between items-center gap-2">
          <span>{t("footer.copyright")}</span>
          <span>support@nakshacart.com</span>
        </div>
      </div>
    </footer>
  );
}
